import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { put } from 'redux-saga/effects';
import qs from 'query-string';
import cookie from 'react-cookies';
import Loader from '@traaidmark/konstruct-part-loader';

import SignupForm from './SignupForm';

import Paths from '../../../constants/paths';

import SessionActions from '../../../redux/actions/session.actions';
import DemandPartnerActions from '../../../redux/actions/demand-partners.actions';
import Action from '../../../redux/actions/helpers/action';
import Effect from '../../../redux/actions/helpers/effect';

import Link from '../../../assets/components/Link';

import Pagelet from '../../../assets/layouts/Pagelet';

class SignUp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      defaultSettings: undefined,
    };
  }

  componentDidMount() {
    if (this.props.defaultSettings.length  === 0) {
      this.props.getDefaultSettings(this.props.domainKey);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props !== prevProps && this.props.defaultSettings?.length > 0) {
      this.setState({
        defaultSettings: this.props.defaultSettings?.[0]
      })
    }
  }

  getSubsystemOrUndefined() {
    return qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).subsystem || undefined;
  }
  render() {
    const {
      signUp,
      sessionLoading,
      domainKey,
     } = this.props;

     const {
      defaultSettings
     } = this.state;

     const headerActions = [
       'Already an investor?',
      <Link
        to={ `${ Paths.SIGN_IN }${ this.props.location ? this.props.location.search : '' }` }
        className="p-button p-button--secondary p-button--small"
      >
        Sign In
      </Link>
     ];

    return (
      <Pagelet
        
        headerActions={ headerActions }
      >
        <Helmet>
          <title>Sign Up</title>
        </Helmet>

        {
          sessionLoading && <Loader text="Signing you up..." />
        }
        {
          !sessionLoading && (
            <SignupForm
              submit={ (data, agreements) => {
                  const demandPartner = defaultSettings?.demand_partner
                  const channelPartner = cookie.load('cp') || qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).cp || defaultSettings?.channel_partner;
                  const legacyPartnerCode = cookie.load('PartnerCode') || qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).PartnerCode || undefined;
                  const campaignCode = cookie.load('cc') || qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).cc || undefined;
                  const registrationUri = (qsCookie) => {
                    switch (typeof qsCookie) {
                      case 'string':
                        return qsCookie;
                      case 'object':
                        return '?'.concat(Object.entries(qsCookie).map(([key, value]) => { return `${ key }=${ value }`; }).join('&'));
                      default:
                        return this.props.location.search || undefined;
                  }
                };
                  signUp(data, domainKey, demandPartner, channelPartner, legacyPartnerCode, campaignCode,
                    registrationUri(cookie.load('query_string')),
                    agreements.map(a => ({ name: a.name, revision_date: a.revision_date, accepted_date: a.accepted_date }))
                    );
                }
              }
              terms={ Paths.TERMS_CONDITIONS }
            /> 
          )
        }

      </Pagelet>
    );
  }
}

SignUp.propTypes = {
  signUp: PropTypes.func,
  sessionLoading: PropTypes.bool,
  submitAgreements: PropTypes.func,
  linkTo: PropTypes.func,
  location: PropTypes.object,
  defaultSettings: PropTypes.object,
  getDefaultSettings: PropTypes.func,
  demandLoading: PropTypes.bool
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
    signUp: (data, subsystem, demandPartner, channelPartner, legacyPartnerCode, campaignCode, registrationUri, agreements) => {
      const signUpData = {
        ...data,
        subsystem,
        demandPartner,
        channelPartner,
        legacyPartnerCode,
        campaignCode,
        registrationUri,
        agreements,
      };

      const successEffect = function* () {
        yield put(push(Paths.BASIC_INFO));
      };

      dispatch(
        Action.withEffect(
          SessionActions.signup(signUpData),
          Effect.create(successEffect)
          )
        );
    },
    linkTo: (path) => { dispatch(push(`${ path }${ ownProps.location.search }`)); },
    getDefaultSettings: (subsystem) => { dispatch(DemandPartnerActions.getDefaults(subsystem)) },
  });
};

const mapStateToProps = (state) => ({
  sessionLoading: state.session.loading,
  domainKey: state?.ui?.ui?.key,
  demandLoading: state?.demand_partners?.loading,
  defaultSettings: state?.demand_partners?.defaultSettings
});

export default connect(mapStateToProps, mapDispatchToProps)(SignUp);
